import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-roi-calculator',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './roi-calculator.component.html',
  styleUrl: './roi-calculator.component.css'
})
export class RoiCalculatorComponent implements OnInit {
  // Inputs
  bugsPerMonth: number = 5;
  resolutionTime: number = 4; // heures
  devHourlyRate: number = 60; // €/h (chargé)
  downtimeMinutes: number = 30; // minutes/mois
  revenueLostPerHour: number = 1000; // €/h
  
  // Computed
  currentMonthlyCost: number = 0;
  optimizedMonthlyCost: number = 0;
  monthlySavings: number = 0;
  annualSavings: number = 0;

  // Chart heights (percentage)
  barCurrentHeight: number = 0;
  barOptimizedHeight: number = 0;

  ngOnInit() {
    this.calculate();
  }

  calculate() {
    // 1. Coût actuel des bugs (Correction)
    const currentBugCost = this.bugsPerMonth * this.resolutionTime * this.devHourlyRate;
    
    // 2. Coût actuel du downtime (Perte CA)
    const currentDowntimeCost = (this.downtimeMinutes / 60) * this.revenueLostPerHour;
    
    this.currentMonthlyCost = currentBugCost + currentDowntimeCost;

    // 3. Situation Mesh-Box
    // -40% de tickets (bugs) grâce à la qualité du code
    // -99% de downtime grâce à l'architecture robuste
    const optimizedBugs = this.bugsPerMonth * 0.6; // 40% reduction
    const optimizedResolutionTime = this.resolutionTime * 0.8; // 20% faster fix (less debt)
    
    const optimizedBugCost = optimizedBugs * optimizedResolutionTime * this.devHourlyRate;
    const optimizedDowntimeCost = 0; // 99.9% uptime target

    this.optimizedMonthlyCost = optimizedBugCost + optimizedDowntimeCost;
    
    this.monthlySavings = this.currentMonthlyCost - this.optimizedMonthlyCost;
    this.annualSavings = this.monthlySavings * 12;

    // Chart Animation (immediate update for reactivity)
    this.barCurrentHeight = 100;
    this.barOptimizedHeight = (this.optimizedMonthlyCost / this.currentMonthlyCost) * 100;
    
    // Safety check for NaN or Infinity if inputs are 0
    if (isNaN(this.barOptimizedHeight) || !isFinite(this.barOptimizedHeight)) {
        this.barOptimizedHeight = 0;
    }
    
    // Min height for visibility
    if (this.barOptimizedHeight < 5 && this.optimizedMonthlyCost > 0) this.barOptimizedHeight = 5;
  }
}
